module.exports = __webpack_public_path__ + "static/img/SAAS标准版背景@2x.ab8854e3.png";